import React from 'react';

const STATE_NAMES: Record<string, string> = {
  AK: 'Alaska',
  AL: 'Alabama',
  AR: 'Arkansas',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WY: 'Wyoming',
};

export const fullStateName = (state?: string): string => {
  const key = (state ?? '').trim().toUpperCase();
  return STATE_NAMES[key] ?? state ?? '—';
};

const PARTY_LABEL: Record<string, string> = { D: 'Democrat', R: 'Republican', I: 'Independent' };

const Badge = ({
  hook,
  className,
  children,
}: {
  hook: 'gov-badge' | 'pill';
  className: string;
  children: React.ReactNode;
}) => (
  <span className={`inline-flex items-center whitespace-nowrap rounded-[7px] px-3 py-1 text-xs font-bold leading-normal ${hook} ${className}`}>
    {children}
  </span>
);

/** Party row-gradient used by SidebarRow. */
export const partyToneClass = (party?: string): string => {
  const key = (party ?? '').trim().toUpperCase().charAt(0);
  if (key === 'D') return 'bg-[linear-gradient(90deg,rgba(63,109,246,0.1)_0%,rgba(63,109,246,0)_70%)]';
  if (key === 'R') return 'bg-[linear-gradient(90deg,rgba(229,72,77,0.1)_0%,rgba(229,72,77,0)_70%)]';
  if (key === 'I') return 'bg-[linear-gradient(90deg,rgba(122,79,211,0.1)_0%,rgba(122,79,211,0)_70%)]';
  return '';
};

export const PartyBadge = ({ party }: { party?: string }) => {
  const key = (party ?? '').trim().toUpperCase().charAt(0);
  if (key === 'D') return <Badge hook="gov-badge" className="bg-[rgba(63,109,246,0.12)] text-[#2f57d9]">{PARTY_LABEL[key]}</Badge>;
  if (key === 'R') return <Badge hook="gov-badge" className="bg-[rgba(229,72,77,0.12)] text-[#c5363c]">{PARTY_LABEL[key]}</Badge>;
  if (key === 'I') return <Badge hook="gov-badge" className="bg-[rgba(122,79,211,0.12)] text-[#5f35b5]">{PARTY_LABEL[key]}</Badge>;
  return <Badge hook="gov-badge" className="bg-[#eef2f8] text-bzgray-600">{party || '—'}</Badge>;
};

export const ChamberBadge = ({ chamber }: { chamber?: string }) => {
  const value = (chamber ?? '').trim();
  const lower = value.toLowerCase();
  if (!value) return <Badge hook="pill" className="bg-[#eef2f8] text-bzgray-600">—</Badge>;
  if (lower === 'house') return <Badge hook="pill" className="bg-[rgba(63,109,246,0.1)] text-[#2f57d9]">{value}</Badge>;
  if (lower === 'senate') return <Badge hook="pill" className="bg-[rgba(180,120,20,0.12)] text-[#9a6b12]">{value}</Badge>;
  return <Badge hook="pill" className="bg-[#eaf0fb] text-[#3f6df6]">{value}</Badge>;
};
